import { SECTION_NAMES } from '@repo/common';

export type GridType = 'horizontal' | 'vertical' | 'top';

export const getGridType = (sectionName: string, isInSingleView: boolean): GridType => {
  if (isInSingleView) {
    return 'vertical';
  }

  const isTopSection = [SECTION_NAMES.TOP, SECTION_NAMES.TOP_GAMES, SECTION_NAMES.MOST_PLAYED].includes(sectionName);

  if (isTopSection) {
    return 'top';
  }

  return 'horizontal';
};
